var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ideas-content"},[(_vm.slide.votingStep === _vm.voteStep.SUBMISSION)?_c('OpenEndedContent'):_c('IdeasVotingContent',{staticClass:"padding"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }